import { Provider } from '@angular/core';
import { GOOGLE_CLIENT_ID } from '@services';

export function provideGoogleClientId(apiKey: string): Provider[] {
  return [{ provide: GOOGLE_CLIENT_ID, useValue: apiKey }];
}
